import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_DOMAIN_PRICE_GENIUS: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateDomainPriceGenius($input: UpdateDomainPriceGeniusInput!) {
    updateDomainPriceGenius(input: $input) {
      domainPriceGenius {
        alwaysOn
        createdAt
        domainId
        id
        priceGeniusEnabled
        sendFloorsToPrebidFloorPriceModule
        trafficPercent
        updatedAt
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
